import React, { useState, useEffect } from 'react';

const Header = () => {

  const [showMenu, setShowMenu] = useState(false);

  const handleClick = () => {
    setShowMenu(!showMenu); // Toggle the state when the button is clicked
  };

  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
  };

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
  }, [theme]);

  return (
    <>
  <svg xmlns="http://www.w3.org/2000/svg" style={{ display: "none" }}>
    <symbol id="svg-link" viewBox="0 0 24 24">
      <title>Link</title>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="feather feather-link"
      >
        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
      </svg>
    </symbol>
  </svg>
  <div id="header">
    <div id="header-subcontainer">
      <a href="https://enbybase.web.app" id="site-icon-and-title-container">
        <span id="site-icon">&nbsp;</span>
        <span id="site-title" translate="no" className="notranslate">
          <span id="site-title-text-xs">NBB</span>
          <span id="site-title-text-sm">NBBase</span>
          <span id="site-title-text-md">EnbyBase</span>
          <span id="site-title-text-lg">EnbyBase Website</span>
        </span>
      </a>
      <span id="top-links">
        <a href="/articles" className="top-link">
          Articles
        </a>
        <a
          href="/discordmods"
          className="top-link"
        >
          Mods
        </a>
        <a href="/discordbot" className="top-link">
          BOT
        </a>
        <button className="top-link" style={{ outline: 'none' }} onClick={handleClick}>
        <b>Rules</b>
        </button>
      
      {/* */}
      {showMenu && (<ul>
        <a href='/rules' className="top-link">Entire Rule</a>
        
        <a href='/openparliament' className="top-link">Parliament</a>
        
       </ul>
       
       )}
       </span>
      {/* */}
      <span id="top-buttons">
        <button
          id="theme-button"
          className="top-button"
          title="Theme (light/dark)"
          onClick={toggleTheme}
        >
          <svg
            id="theme-button-light-svg"
            className="top-button-svg"
            width={20}
            height={20}
            viewBox="0 0 32 32"
            
          >
            <path d="M16 12.005a4 4 0 1 1-4 4a4.005 4.005 0 0 1 4-4m0-2a6 6 0 1 0 6 6a6 6 0 0 0-6-6z" />
            <path d="M5.394 6.813l1.414-1.415l3.506 3.506L8.9 10.318z" />
            <path d="M2 15.005h5v2H2z" />
            <path d="M5.394 25.197L8.9 21.691l1.414 1.415l-3.506 3.505z" />
            <path d="M15 25.005h2v5h-2z" />
            <path d="M21.687 23.106l1.414-1.415l3.506 3.506l-1.414 1.414z" />
            <path d="M25 15.005h5v2h-5z" />
            <path d="M21.687 8.904l3.506-3.506l1.414 1.415l-3.506 3.505z" />
            <path d="M15 2.005h2v5h-2z" />
          </svg>
          <svg
            id="theme-button-dark-svg"
            className="top-button-svg"
            width={20}
            height={20}
            viewBox="0 0 32 32"
          >
            <path d="M13.502 5.414a15.075 15.075 0 0 0 11.594 18.194a11.113 11.113 0 0 1-7.975 3.39c-.138 0-.278.005-.418 0a11.094 11.094 0 0 1-3.2-21.584M14.98 3a1.002 1.002 0 0 0-.175.016a13.096 13.096 0 0 0 1.825 25.981c.164.006.328 0 .49 0a13.072 13.072 0 0 0 10.703-5.555a1.01 1.01 0 0 0-.783-1.565A13.08 13.08 0 0 1 15.89 4.38A1.015 1.015 0 0 0 14.98 3z" />
          </svg>
        </button>
        <button id="language-button" className="top-button" title="Translate">
          <svg
            className="top-button-svg"
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            viewBox="0 0 24 24"
          >
            <path d="M12.65 15.67c.14-.36.05-.77-.23-1.05l-2.09-2.06.03-.03c1.74-1.94 2.98-4.17 3.71-6.53h1.94c.54.0.99-.45.99-.99v-.02c0-.54-.45-.99-.99-.99H10V3c0-.55-.45-1-1-1s-1 .45-1 1v1H1.99c-.54.0-.99.45-.99.99.0.55.45.99.99.99h10.18C11.5 7.92 10.44 9.75 9 11.35c-.81-.89-1.49-1.86-2.06-2.88-.16-.29-.45-.47-.78-.47-.69.0-1.13.75-.79 1.35.63 1.13 1.4 2.21 2.3 3.21L3.3 16.87c-.4.39-.4 1.03.0 1.42.39.39 1.02.39 1.42.0L9 14l2.02 2.02c.51.51 1.38.32 1.63-.35zM17.5 10c-.6.0-1.14.37-1.35.94l-3.67 9.8c-.24.61.22 1.26.87 1.26.39.0.74-.24.88-.61l.89-2.39h4.75l.9 2.39c.14.36.49.61.88.61.65.0 1.11-.65.88-1.26l-3.67-9.8c-.22-.57-.76-.94-1.36-.94zm-1.62 7 1.62-4.33L19.12 17h-3.24z" />
          </svg>
        </button>
        <button id="search-button" className="top-button" title="Search">
          <svg
            version="1.1"
            className="top-button-svg"
            width={24}
            height={24}
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
          >
            <g>
              <path d="M19.4271164,21.4271164 C18.0372495,22.4174803 16.3366522,23 14.5,23 C9.80557939,23 6,19.1944206 6,14.5 C6,9.80557939 9.80557939,6 14.5,6 C19.1944206,6 23,9.80557939 23,14.5 C23,16.3366522 22.4174803,18.0372495 21.4271164,19.4271164 L27.0119176,25.0119176 C27.5621186,25.5621186 27.5575313,26.4424687 27.0117185,26.9882815 L26.9882815,27.0117185 C26.4438648,27.5561352 25.5576204,27.5576204 25.0119176,27.0119176 L19.4271164,21.4271164 L19.4271164,21.4271164 Z M14.5,21 C18.0898511,21 21,18.0898511 21,14.5 C21,10.9101489 18.0898511,8 14.5,8 C10.9101489,8 8,10.9101489 8,14.5 C8,18.0898511 10.9101489,21 14.5,21 L14.5,21 Z" />
            </g>
          </svg>
        </button>
        <button
          id="toc-button-mobile"
          className="top-button"
          title="Miles (Ctrl+Shift+L)"
        ><a href="/miles">
          <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="16pt" height="16pt" viewBox="0 0 1280.000000 1207.000000"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,1207.000000) scale(0.100000,-0.100000)"
fill="#9C59D1" stroke="none">
<path d="M2897 12013 c-9 -32 -79 -300 -157 -595 -252 -967 -420 -1611 -445
-1703 -13 -49 -92 -351 -175 -670 -83 -319 -160 -611 -170 -650 -10 -38 -73
-279 -140 -535 -67 -256 -130 -496 -140 -535 -10 -38 -87 -331 -170 -650 -83
-319 -162 -620 -175 -670 -13 -49 -87 -332 -165 -627 -363 -1392 -423 -1620
-450 -1723 -16 -60 -93 -353 -170 -650 -78 -297 -220 -839 -315 -1205 -96
-366 -185 -708 -199 -760 -19 -69 -26 -120 -26 -187 0 -51 2 -93 5 -93 3 0
231 -27 508 -60 276 -33 902 -107 1392 -165 490 -57 932 -110 983 -116 51 -6
94 -10 96 -8 2 2 38 180 79 394 198 1017 481 2472 557 2860 179 920 220 1132
220 1147 0 34 15 17 53 -60 88 -180 1503 -2992 1532 -3047 18 -33 218 -430
445 -883 l412 -823 110 3 111 3 1249 2410 c687 1326 1252 2413 1256 2417 4 4
26 -90 49 -210 23 -119 91 -471 152 -782 61 -311 129 -659 151 -775 22 -115
74 -382 115 -593 41 -210 109 -554 150 -765 41 -210 92 -474 114 -587 22 -113
62 -317 88 -454 26 -137 53 -250 59 -253 9 -3 2417 285 2814 337 41 5 81 10
88 10 9 0 12 25 12 90 0 86 -58 323 -1391 5655 l-1392 5566 -125 -3 -125 -3
-1686 -3310 -1686 -3309 -126 259 c-70 143 -326 667 -569 1165 -244 498 -487
995 -540 1105 -92 189 -402 824 -1406 2878 -241 490 -472 965 -515 1055 l-78
162 -124 0 -124 0 -16 -57z"/>
</g>
</svg></a>
        </button>
        <button
          id="hide-persistent-header-button"
          className="top-button"
          title="Hide top bar (Ctrl+Shift+H)"
        >
          <svg
            id="hide-persistent-header-button-svg"
            version="1.1"
            x="0px"
            y="0px"
            width="20px"
            height="20px"
            viewBox="0 0 24 24"
            enableBackground="new 0 0 24 24"
            xmlSpace="preserve"
            fill="#5F6368"
          >
            <path d="M8.59,16.59L13.17,12L8.59,7.41L10,6l6,6l-6,6L8.59,16.59z" />
            <path fill="none" d="M0,0h24v24H0V0z" />
          </svg>
        </button>
      </span>
    </div>
    <div id="mobile-menu">
    <span id="top-links-mobile" style={{ textAlign: "center" }}>
        <a href="/articles" className="top-link">
          Articles
        </a>
        <a
          href="/discordmods" className="top-link"
        >
          Mods
        </a>
        <a href="/discordbot" className="top-link">
          BOT
        </a>
        <button className="top-link" onClick={handleClick}>
        <p style={{ fontWeight: 'bold' }}>Rules</p>
        </button>
        {showMenu && (
          <div>
        <a href='/rules' className="top-link">Entire Rule</a>
        
        <a href='/openparliament' className="top-link">Parliament</a>
        
        </div>
       
       )}
      </span>
    </div>
  </div>
  <button
    id="restore-persistent-header-button"
    className="top-button"
    title="Show top bar (Ctrl+Shift+H)"
  >
    <svg
      id="restore-persistent-header-button-svg"
      version="1.1"
      x="0px"
      y="0px"
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
      xmlSpace="preserve"
      fill="#5F6368"
    >
      <path d="M8.59,16.59L13.17,12L8.59,7.41L10,6l6,6l-6,6L8.59,16.59z" />
      <path fill="none" d="M0,0h24v24H0V0z" />
    </svg>
  </button>
  <div id="mid-section">
    <div id="sidebar">
      <div id="sidebar-subcontainer">
        <div id="sidebar-title-container">
          <button
            id="sidebar-button"
            className="sidebar-button"
            title="Miles (Ctrl+Shift+L)"
          >
            <span className="sidebar-button-icon"><a href="/miles">
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="16pt" height="16pt" viewBox="0 0 1280.000000 1207.000000"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,1207.000000) scale(0.100000,-0.100000)"
fill="#9C59D1" stroke="none">
<path d="M2897 12013 c-9 -32 -79 -300 -157 -595 -252 -967 -420 -1611 -445
-1703 -13 -49 -92 -351 -175 -670 -83 -319 -160 -611 -170 -650 -10 -38 -73
-279 -140 -535 -67 -256 -130 -496 -140 -535 -10 -38 -87 -331 -170 -650 -83
-319 -162 -620 -175 -670 -13 -49 -87 -332 -165 -627 -363 -1392 -423 -1620
-450 -1723 -16 -60 -93 -353 -170 -650 -78 -297 -220 -839 -315 -1205 -96
-366 -185 -708 -199 -760 -19 -69 -26 -120 -26 -187 0 -51 2 -93 5 -93 3 0
231 -27 508 -60 276 -33 902 -107 1392 -165 490 -57 932 -110 983 -116 51 -6
94 -10 96 -8 2 2 38 180 79 394 198 1017 481 2472 557 2860 179 920 220 1132
220 1147 0 34 15 17 53 -60 88 -180 1503 -2992 1532 -3047 18 -33 218 -430
445 -883 l412 -823 110 3 111 3 1249 2410 c687 1326 1252 2413 1256 2417 4 4
26 -90 49 -210 23 -119 91 -471 152 -782 61 -311 129 -659 151 -775 22 -115
74 -382 115 -593 41 -210 109 -554 150 -765 41 -210 92 -474 114 -587 22 -113
62 -317 88 -454 26 -137 53 -250 59 -253 9 -3 2417 285 2814 337 41 5 81 10
88 10 9 0 12 25 12 90 0 86 -58 323 -1391 5655 l-1392 5566 -125 -3 -125 -3
-1686 -3310 -1686 -3309 -126 259 c-70 143 -326 667 -569 1165 -244 498 -487
995 -540 1105 -92 189 -402 824 -1406 2878 -241 490 -472 965 -515 1055 l-78
162 -124 0 -124 0 -16 -57z"/>
</g>
</svg></a>
            </span>
          </button>
          <span id="sidebar-title">Contents</span>
        </div>
        <div id="sidebar-contents">
          <div className="toc-h1">
            <a id="heading-0" href="#top" className="toc-link">
              Top of page
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</>

  );
}


export default Header;